<div class="default-dialog-layout">
    <div class="title">Select Layers for {{ data.inputName }}</div>

    <form class="dialog-content">
        <cds-form-group layout="vertical">
            <div class="layer-selection-section">
                <div class="section-header">
                    <input
                        type="text"
                        class="search-input"
                        placeholder="Search..."
                        [(ngModel)]="searchQuery"
                        name="layerSearch"
                    />
                </div>
                <div class="layer-selection-list">
                    <ng-container *ngFor="let layer of filteredLayers">
                        <cds-checkbox>
                            <label>{{ layer.name }}</label>
                            <input
                                type="checkbox"
                                [checked]="isLayerSelected(layer)"
                                [disabled]="isLayerDisabled(layer)"
                                (change)="toggleLayer(layer)"
                            />
                        </cds-checkbox>
                    </ng-container>
                </div>
            </div>
        </cds-form-group>
    </form>

    <div class="actions action-buttons">
        <cds-button size="sm" action="flat" (click)="clear()">Clear</cds-button>
        <cds-button size="sm" action="flat" (click)="cancel()">Cancel</cds-button>
        <cds-button size="sm" (click)="confirm()" [disabled]="!canConfirm()">Confirm</cds-button>
    </div>
</div>
